import { ContestarEncuestaComponent } from "../../Components/Encuestas/ContestarEncuestaComponent"
import { LogoHeader } from '../../Components/Inicio/LogoHeaderComponent';
import { NavDesktop } from '../../Components/Inicio/NavDesktop';
import { NavMobile } from '../../Components/Inicio/NavMobile';
import { Footer } from '../../Components/Footer/FooterComponent';


export const ContestarEncuesta = (props) =>{
    return(
        <>
        <LogoHeader I18n={props.I18n} />
        <NavDesktop I18n={props.I18n} />
        <NavMobile I18n={props.I18n} />
        <ContestarEncuestaComponent I18n={props.I18n} user={props.User}/>
        <Footer I18n={props.I18n} />
        </>
    )

}